<template>
  <InSharesContext v-if="accountId" :organization-id="accountId">
    <RouterView></RouterView>
  </InSharesContext>
</template>

<script setup lang="ts">
import InSharesContext from '@/components/deepbox/in-shares/InSharesContext.vue'

definePage({
  props: true,
})

defineProps({
  accountId: {
    type: String,
    required: true,
  },
})
</script>
